"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo, type ReactElement } from "react";
import { XtdhStats } from "@/components/xtdh/stats";
import { buildGlobalXtdhStatsContent } from "@/components/xtdh/stats/buildGlobalXtdhStatsContent";
import { useGlobalTdhStats } from "@/hooks/useGlobalTdhStats";
import XtdhReceivedSection from "./received";
export default function XtdhPage() {
  const $ = _c(16);
  const globalStatsQuery = useGlobalTdhStats();
  let t0;
  bb0: {
    if (!globalStatsQuery.data) {
      t0 = null;
      break bb0;
    }
    let t1;
    if ($[0] !== globalStatsQuery.data) {
      t1 = buildGlobalXtdhStatsContent(globalStatsQuery.data);
      $[0] = globalStatsQuery.data;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    t0 = t1;
  }
  const statsContent = t0;
  let statsSection;
  if (globalStatsQuery.isLoading) {
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <XtdhStatsSkeleton />;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    statsSection = t1;
  } else {
    if (globalStatsQuery.isError || !statsContent) {
      const t1 = globalStatsQuery.error?.message ?? "Failed to load xTDH stats.";
      let t2;
      if ($[3] !== globalStatsQuery) {
        t2 = () => {
          globalStatsQuery.refetch().catch(_temp);
        };
        $[3] = globalStatsQuery;
        $[4] = t2;
      } else {
        t2 = $[4];
      }
      let t3;
      if ($[5] !== t1 || $[6] !== t2) {
        t3 = <XtdhStatsError message={t1} onRetry={t2} />;
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
      } else {
        t3 = $[7];
      }
      statsSection = t3;
    } else {
      let t1;
      if ($[8] !== statsContent) {
        t1 = <XtdhStats {...statsContent} />;
        $[8] = statsContent;
        $[9] = t1;
      } else {
        t1 = $[9];
      }
      statsSection = t1;
    }
  }
  let t1;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <header><h1 className="tw-m-0 tw-text-lg tw-font-semibold tw-text-iron-50">xTDH Network Overview</h1><p className="tw-mt-1 tw-text-sm tw-text-iron-400">Live network-wide TDH and xTDH metrics, including the share already granted.</p></header>;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  let t2;
  if ($[11] !== statsSection) {
    t2 = <section className="tw-space-y-4">{t1}<div className="tw-mt-2">{statsSection}</div></section>;
    $[11] = statsSection;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  let t3;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <XtdhReceivedSection profileId={null} requireIdentity={false} />;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== t2) {
    t4 = <div className="tailwind-scope tw-space-y-6">{t2}{t3}</div>;
    $[14] = t2;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
}
function _temp() {}
function XtdhStatsSkeleton() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="tw-grid tw-grid-cols-1 tw-gap-4 md:tw-grid-cols-3">{[0, 1, 2].map(_temp2)}</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <output aria-live="polite" aria-busy="true" className="tw-block tw-animate-pulse tw-space-y-4">{t0}<div className="tw-space-y-2 tw-rounded-xl tw-border tw-border-iron-800 tw-bg-iron-900 tw-p-4"><div className="tw-h-3 tw-w-28 tw-rounded tw-bg-iron-800" /><div className="tw-h-2 tw-w-full tw-rounded-full tw-bg-iron-800" /><div className="tw-h-4 tw-w-48 tw-rounded tw-bg-iron-800" /></div></output>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp2(key) {
  return <div key={`xtdh-skeleton-metric-${key}`} className="tw-rounded-xl tw-border tw-border-iron-800 tw-bg-iron-900 tw-p-4 tw-space-y-2"><div className="tw-h-3 tw-w-24 tw-rounded tw-bg-iron-800" /><div className="tw-h-6 tw-w-28 tw-rounded tw-bg-iron-700" /></div>;
}
function XtdhStatsError(t0) {
  const $ = _c(8);
  const {
    message,
    onRetry
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className="tw-m-0 tw-text-sm tw-font-semibold tw-text-rose-200">Unable to load xTDH stats</p>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== message) {
    t2 = <div>{t1}<p className="tw-mt-1 tw-text-sm tw-text-rose-200/80">{message}</p></div>;
    $[1] = message;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onRetry) {
    t3 = <button type="button" onClick={onRetry} className="tw-rounded-lg tw-border tw-border-solid tw-border-rose-800 tw-bg-rose-900 tw-px-3 tw-py-1.5 tw-text-sm tw-font-semibold tw-text-rose-100 desktop-hover:hover:tw-bg-rose-800">Retry</button>;
    $[3] = onRetry;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div role="alert" className="tw-flex tw-items-start tw-justify-between tw-gap-3 tw-rounded-xl tw-border tw-border-rose-900 tw-bg-rose-950/40 tw-p-4">{t2}{t3}</div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}